module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robin A. Leaver\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Robin A. Leaver")]), _vm._v(" is professor emeritus at Westminster Choir College and visiting professor at Yale University and Queen's University, Belfast, Northern Ireland. His previous books include "), _c('I', [_vm._v("Luther's Liturgical Music: Principles and Implications")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CIDRiS/tc-custom/9781467447003.jpg?1730410102514",
      "alt": "This image is the cover for the book The Whole Church Sings, The Calvin Institute of Christian Worship Liturgical Studies (CICW)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Whole Church Sings, The Calvin Institute of Christian Worship Liturgical Studies (CICW)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Authoritative study by a renowned musicologist and Reformation scholar")]), _c('br'), _c('br'), _vm._v(" Many scholars think that congregational singing was not established in Lutheran worship until well after the start of the Reformation. In this book Robin A. Leaver calls that view into question, presenting new research to confirm the earlier view that congregational singing was both the intention and the practice right from the beginning of the Wittenberg reforms in worship."), _c('br'), _c('br'), _vm._v(" Leaver's study focuses on the Wittenberg hymnal of 1526, which until now has received little scholarly attention. This hymnal, Leaver argues, shows how the Lutheran Reformation was to a large degree defined, expressed, promoted, and taken to heart through early Lutheran hymns. Examining what has been forgotten or neglected about the origins of congregational hymnody under Martin Luther's leadership, this study of worship, music, and liturgy is a significant contribution to Reformation scholarship.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0